import { CartGradeOptionDiscountUrl, CartSummaryUrl } from "../directives/utilities/urls";
/*****************************************************************************************************************************************************
 * Revision History
 * 2025-03-03 TBH - Created resetAddressValidators() method to clear address validators, removed redundant lines of code doing same in updateAddressData() (halved #lines!)
 * 2025-03-04 TBH - Removed "U.S.A." from list of selectable countries for international address.
 * 2025-03-04 TBH - Province optional on Business address if country is not "U.S.A."
 * 2025-03-05 TBH - Also require business address 1.
 * 2025-03-27 TBH - Handle enrollment blocked by state.
 * 2025-04-09 TBH - Changed hasEnrollmentBlock to hasCourseEnrollmentBlock to clarify it's value is People.HasEnrollmentBlock && cart type is Course.
 *****************************************************************************************************************************************************/
export default function updateProfileDetails() {
// console.log( 'updateProfileDetails - ' + new Date().toLocaleString());
  return {
    ethnicitiesList: [],
    isEthinicity: true,
    errorisEthinicity: '',
    passedEthnicity: '',
    localAddressCountry: [],
    businessAddressCountry: [],
    permanentAddressCountry: [],
    addresses: {
      local: { address1: '', address2: '', address3: '', city: '', state: '', country: '', province: '', company: '', position: '', isPreferredAddress: false, zipCode: '', addressType: 1 },
      business: { address1: '', address2: '', address3: '', city: '', state: '', country: '', province: '', company: '', position: '', isPreferredAddress: false, zipCode: '', addressType: 2 },
      permanent: { address1: '', address2: '', address3: '', city: '', state: '', country: '', province: '', company: '', position: '', isPreferredAddress: false, zipCode: '', addressType: 3 },
    },
    emailAddress: '',
    errorMessage: '',
    isLocalSubmitted: false,
    isBusinessSubmitted: false,
    isPermanentSubmitted: false,
    isCellPhoneCountryError: false,
    requiredMessage: 'This field is Required',

    message: '',
    zotAlertChecked: false,
    businessAddress: '',
    localAddress: '',
    permanentAddress: '',
    passedBusinessAddress1: '',
    passedBusinessAddress2: '',
    passedBusinessAddress3: '',
    passedBusinessCity: '',
    passedBusinessState: '',
    passedBusinessCountry: '',
    passedBusinessProvince: '',
    passedBusinessCompany: '',
    passedBusinessPosition: '',
    passedBusinessIsPreferredAddress: '',
    passedBusinessZipCode: '',

    passedLocalAddress1: '',
    passedLocalAddress2: '',
    passedLocalAddress3: '',
    passedLocalCity: '',
    passedLocalState: '',
    passedLocalCountry: '',
    passedLocalProvince: '',
    passedLocalCompany: '',
    passedLocalPosition: '',
    passedLocalIsPreferredAddress: '',
    passedLocalZipCode: '',

    passedPermanentAddress1: '',
    passedPermanentAddress2: '',
    passedPermanentAddress3: '',
    passedPermanentCity: '',
    passedPermanentState: '',
    passedPermanentCountry: '',
    passedPermanentProvince: '',
    passedPermanentCompany: '',
    passedPermanentPosition: '',
    passedPermanentIsPreferredAddress: '',
    passedPermanentZipCode: '',

    isBusinessAddress1: true,
    isBusinessAddress2: true,
    isBusinessAddress3: true,
    isBusinessCity: true,
    isBusinessState: true,
    isBusinessCountry: true,
    isBusinessProvince: true,
    isBusinessCompany: true,
    isBusinessPosition: true,
    isBusinessIsPreferredAddress: true,
    isBusinessZipCode: true,

    isLocalAddress1: true,
    isLocalAddress2: true,
    isLocalAddress3: true,
    isLocalCity: true,
    isLocalState: true,
    isLocalCountry: true,
    isLocalProvince: true,
    isLocalCompany: true,
    isLocalPosition: true,
    isLocalIsPreferredAddress: true,
    isLocalZipCode: true,

    isPermanentAddress1: true,
    isPermanentAddress2: true,
    isPermanentAddress3: true,
    isPermanentCity: true,
    isPermanentState: true,
    isPermanentCountry: true,
    isPermanentProvince: true,
    isPermanentCompany: true,
    isPermanentPosition: true,
    isPermanentIsPreferredAddress: true,
    isPermanentZipCode: true,

    isBusinessAddress1Error: '',
    isBusinessAddress2Error: '',
    isBusinessAddress3Error: '',
    isBusinessCityError: '',
    isBusinessStateError: '',
    isBusinessCountryError: '',
    isBusinessProvinceError: '',
    isBusinessCompanyError: '',
    isBusinessPositionError: '',
    isBusinessIsPreferredAddressError: '',
    isBusinessZipCodeError: '',

    isLocalAddress1Error: '',
    isLocalAddress2Error: '',
    isLocalAddress3Error: '',
    isLocalCityError: '',
    isLocalStateError: '',
    isLocalCountryError: '',
    isLocalProvinceError: '',
    isLocalCompanyError: '',
    isLocalPositionError: '',
    isLocalIsPreferredAddressError: '',
    isLocalZipCodeError: '',

    isPermanentAddress1Error: '',
    isPermanentAddress2Error: '',
    isPermanentAddress3Error: '',
    isPermanentCityError: '',
    isPermanentStateError: '',
    isPermanentCountryError: '',
    isPermanentProvinceError: '',
    isPermanentCompanyError: '',
    isPermanentPositionError: '',
    isPermanentIsPreferredAddressError: '',
    isPermanentZipCodeError: '',
    isMessage: true,
    isSubmitting: false,
    isValidContactDetails: false,
    permanentAddressStates: [],
    businessAddressStates: [],
    localAddressStates: [],

    mobileCountry: [],
    businessCountry: [],
    homeCountry: [],
    phones: {
      mobile: { country: '', phone: '', isPrimary: false, phoneType: 0 },
      business: { country: '', phone: '', isPrimary: false, phoneType: 0 },
      home: { country: '', phone: '', isPrimary: false, phoneType: 0 },
    },

    phoneDetails: '',
    primaryPhone: '',

    passedhomePhone: '',
    passedBusinessPhone: '',
    passedmobilePhone: '',

    ishomePhone: true,
    isBusinessPhone: true,
    ismobilePhone: true,

    isHomePhoneError: false,
    isBusinessPhoneError: false, 
    isMobilePhoneError: false,

    passedBusinessCountry: '',
    passedmobileCountry: '',
    passedhomeCountry: '',

    isBusinessCountry: true,
    ismobileCountry: true,
    ishomeCountry: true,

    isBusinessCountryError: '',
    ismobileCountryError: '',
    ishomeCountryError: '',

    seasonList: [],
    seasonFistTermYear: '',

    hasCourseEnrollmentBlock: false,      // People.HasEnrollmentBlocked && Session.CurrentCheckoutType == CheckoutType.Course.

    fetchCountry() {
// console.log( "fetchCountry()" );
      fetch('/api/common/GetCountry').then((response) => {
        if (response.ok) {
          return response.json()
        }
      }).then(( addressCountry ) => {
// console.log( 'response: ' + JSON.stringify( addressCountry ));
        this.localAddressCountry = addressCountry;
        this.businessAddressCountry = addressCountry;
        this.permanentAddressCountry = addressCountry.filter( c => c.value != "U.S.A." );
      }).catch((error) => {
        console.error(error);
      });
    },

    fetchContactCountry() {
      fetch( '/api/common/GetCountries' ).then((response) => {
        if (response.ok) {
          return response.json()
        }
      }).then(( json ) => {
        this.mobileCountry = json;
        this.businessCountry = json;
        this.homeCountry = json;
      }).catch((error) => {
        console.error(error);
      });
    },

    mobilePhoneZotAlertClick() {
      this.zotAlertChecked = true;
    },

        formatPhoneNumber(phoneNumber) {
            if (phoneNumber.length === 10) {
                var maskedPhone = "";
                phoneNumber = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
                const match = phoneNumber.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
                maskedPhone = match ? `(${match[1]}) ${match[2]}-${match[3]}` : ''
                return maskedPhone;
            }
            else if (phoneNumber.length > 10) {

                var maskedPhone = "";
                phoneNumber = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
                phoneNumber = phoneNumber.substring(0, 10);
                const match = phoneNumber.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
                maskedPhone = match ? `(${match[1]}) ${match[2]}-${match[3]}` : ''
                return maskedPhone;
            }
            else {
                return "";
            }
        },
        formatCellNumber(countryCode, phoneNumber) {
            if (countryCode === 'U.S.A.') {
                this.phones.mobile.phone = this.formatPhoneNumber(phoneNumber);
            }
            else {
                this.phones.mobile.phone = phoneNumber.replace(/\D/g, '');
            }

        },
        formatHomeNumber(countryCode, phoneNumber) {
            if (countryCode === 'U.S.A.') {
                this.phones.home.phone = this.formatPhoneNumber(phoneNumber);
            }
            else {
                this.phones.home.phone = phoneNumber.replace(/\D/g, '');
            }

        },
        formatWorkNumber(countryCode, phoneNumber) {
            if (countryCode === 'U.S.A.') {
                this.phones.business.phone = this.formatPhoneNumber(phoneNumber);
            }
            else {
                this.phones.business.phone = phoneNumber.replace(/\D/g, '');
            }

        },
        bindSeasonList() {

            fetch('/api/ProgramAPI/GetSeasonList?top=' + 2, { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        Array.prototype.push.apply(this.seasonList, response.seasons)
                        this.seasonFistTermYear = this.seasonList[0].academicTerm.toUpperCase() + this.seasonList[0].academicYear;
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },

        bindPhoneDetails() {

            fetch('/api/checkout/get-phone-details', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.phoneDetails = response.phoneDetails;
                        this.phones.mobile.phone = this.phoneDetails.cellPhoneCountryId === 'U.S.A.' || this.phoneDetails.homePhoneCountryId === 261 ? this.formatPhoneNumber(this.phoneDetails.cellPhone) : this.phoneDetails.cellPhone;
                        this.phones.mobile.country = this.phoneDetails.cellPhoneCountryId.toString();
                        this.phones.business.phone = this.phoneDetails.workPhoneCountryId === 'U.S.A.' || this.phoneDetails.homePhoneCountryId === 261 ? this.formatPhoneNumber(this.phoneDetails.workPhone) : this.phoneDetails.workPhone;
                        this.phones.business.country = this.phoneDetails.workPhoneCountryId.toString();;
                        this.phones.home.phone = this.phoneDetails.homePhoneCountryId === 'U.S.A.' || this.phoneDetails.homePhoneCountryId === 261 ? this.formatPhoneNumber(this.phoneDetails.homePhone) : this.phoneDetails.homePhone;
                        this.phones.home.country = this.phoneDetails.homePhoneCountryId.toString();;
                        this.primaryPhone = this.phoneDetails.primaryPhone;
                        this.phoneDetails.homePhoneCountryId = 'U.S.A.';
                        if (this.primaryPhone == "HOME") {
                            this.phones.home.isPrimary = true;
                        }
                        if (this.primaryPhone == "WORK") {
                            this.phones.business.isPrimary = true;
                        }
                        if (this.primaryPhone == "CELL") {
                            this.phones.mobile.isPrimary = true;
                        }

                        this.bindSeasonList();


                    } else {
                        this.showErrorMesage = "Something went wrong."
                    }

                });

        },

    bindAddresses() {
// console.log( 'bindAddresses()' );
      fetch('/api/UserAPI/GetProfile', { "method": "GET" })
          .then(response => {
              if (response.ok) {
                  return response.json()
              }
          }).then(response => {
// console.log( 'response: ' + JSON.stringify( response ));
        if (response != undefined && response.isSuccess) {
          this.showErrorMesage = "";
          this.passedEthnicity = response.people.ethnicityId;
          this.zotAlertChecked = response.zotAlertChecked;
          this.phones.mobile.isPrimary = true;
          this.bindPhoneDetails();
          this.businessAddress = response.businessAddress;
          this.localAddress = response.localAddress;
          this.permanentAddress = response.permanentAddress;

          this.addresses.local.address1 = this.localAddress.address1 == null ? "" : this.localAddress.address1;
          this.addresses.local.address2 = this.localAddress.address2 == null ? "" : this.localAddress.address2;
          this.addresses.local.address3 = this.localAddress.address3 == null ? "" : this.localAddress.address3;
          this.addresses.local.city = this.localAddress.city == null ? "" : this.localAddress.city;
          this.addresses.local.state = this.localAddress.state == null ? "" : this.localAddress.state;

          this.addresses.local.addressType = this.localAddress.addressType == null ? false : this.localAddress.addressType;
          this.addresses.local.zipCode = this.localAddress.zipCode == null ? "" : this.localAddress.zipCode;
          if (response.people.preferredAddressType == 1) {
              this.addresses.local.isPreferredAddress = true;
          }

          this.addresses.business.address1 = this.businessAddress.address1 == null ? "" : this.businessAddress.address1;
          this.addresses.business.address2 = this.businessAddress.address2 == null ? "" : this.businessAddress.address2;
          this.addresses.business.company = this.businessAddress.company == null ? "" : this.businessAddress.company;
          this.addresses.business.city = this.businessAddress.city == null ? "" : this.businessAddress.city;
          this.addresses.business.state = this.businessAddress.state == null ? "" : this.businessAddress.state;
          this.addresses.business.province = this.businessAddress.province == null ? "" : this.businessAddress.province;
          this.addresses.business.country = this.businessAddress.country == null ? "" : this.businessAddress.country;
          this.addresses.business.addressType = this.businessAddress.addressType == null ? false : this.businessAddress.addressType;
          this.addresses.business.zipCode = this.businessAddress.zipCode == null ? "" : this.businessAddress.zipCode;
          if (response.people.preferredAddressType == 2) {
              this.addresses.business.isPreferredAddress = true;
          }

          this.addresses.permanent.address1 = this.permanentAddress.address1 == null ? "" : this.permanentAddress.address1;
          this.addresses.permanent.address2 = this.permanentAddress.address2 == null ? "" : this.permanentAddress.address2;
          this.addresses.permanent.address3 = this.permanentAddress.address3 == null ? "" : this.permanentAddress.address3;
          this.addresses.permanent.city = this.permanentAddress.city == null ? "" : this.permanentAddress.city;
          this.addresses.permanent.province = this.permanentAddress.province == null ? "" : this.permanentAddress.province;
          this.addresses.permanent.country = this.permanentAddress.country == null ? "" : this.permanentAddress.country;
          this.addresses.permanent.addressType = this.permanentAddress.addressType == null ? false : this.permanentAddress.addressType;
          this.addresses.permanent.zipCode = this.permanentAddress.zipCode == null ? "" : this.permanentAddress.zipCode;
          if( response.people.preferredAddressType == 3 ) {
            this.addresses.permanent.isPreferredAddress = true;
          }
          this.hasCourseEnrollmentBlock = response.hasCourseEnrollmentBlock;
        } else {
          this.showErrorMesage = "An unknown error has occurred. Please try again later."
        }
      });
    },

        resetData() {
            this.isMessage = true;
            this.message = "";
            this.passedBusinessAddress1 = "";
            this.passedBusinessAddress2 = "";
            this.passedBusinessAddress3 = "";
            this.passedBusinessCity = "";
            this.passedBusinessState = "";
            this.passedBusinessCountry = "";
            this.passedBusinessProvince = "";
            this.passedBusinessCompany = "";
            this.passedBusinessPosition = "";
            this.passedBusinessIsPreferredAddress = "";
            this.passedBusinessZipCode = "";

            this.passedLocalAddress1 = "";
            this.passedLocalAddress2 = "";
            this.passedLocalAddress3 = "";
            this.passedLocalCity = "";
            this.passedLocalState = "";
            this.passedLocalCountry = "";
            this.passedLocalProvince = "";
            this.passedLocalCompany = "";
            this.passedLocalPosition = "";
            this.passedLocalIsPreferredAddress = "";
            this.passedLocalZipCode = "";

            this.passedPermanentAddress1 = "";
            this.passedPermanentAddress2 = "";
            this.passedPermanentAddress3 = "";
            this.passedPermanentCity = "";
            this.passedPermanentState = "";
            this.passedPermanentCountry = "";
            this.passedPermanentProvince = "";
            this.passedPermanentCompany = "";
            this.passedPermanentPosition = "";
            this.passedPermanentIsPreferredAddress = "";
            this.passedPermanentZipCode = "";

        },
        resetMessge() {
            this.message = "";

        },
        localClick() {
            this.addresses.local.isPreferredAddress = true;
            this.addresses.business.isPreferredAddress = false;
            this.addresses.permanent.isPreferredAddress = false;
            this.message = "";
            this.isMessage = true;
        },
        homePrimaryClick() {
            this.phones.home.isPrimary = true;
            this.phones.mobile.isPrimary = false;
            this.phones.business.isPrimary = false;
            this.isBusinessPhoneError = false;
            this.isHomePhoneError = false;
            this.isMobilePhoneError = false;
        },
        mobilePrimaryClick() {
            this.phones.mobile.isPrimary = true;
            this.phones.home.isPrimary = false;
            this.phones.business.isPrimary = false;
            this.isBusinessPhoneError = false;
            this.isHomePhoneError = false;
            this.isMobilePhoneError = false;
        },
        businessPrimaryClick() {
            this.phones.business.isPrimary = true;
            this.phones.mobile.isPrimary = false;
            this.phones.home.isPrimary = false;
            this.isBusinessPhoneError = false;
            this.isHomePhoneError = false;
            this.isMobilePhoneError = false;
        },
        businessClick() {
            this.addresses.local.isPreferredAddress = false;
            this.addresses.business.isPreferredAddress = true;
            this.addresses.permanent.isPreferredAddress = false;
            this.message = "";
            this.isMessage = true;
        },
        permanentClick() {
            this.addresses.local.isPreferredAddress = false;
            this.addresses.business.isPreferredAddress = false;
            this.addresses.permanent.isPreferredAddress = true;
            this.message = "";
            this.isMessage = true;
        },
        fetchEthnicities() {
// console.log( 'fetchEthnicities()' );
            fetch(' /api/common/ethnicities')
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                })
                .then((json) => {
                    this.ethnicitiesList = json;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        getStates() {
// console.log( 'getStates()' );
            fetch('/api/common/getstates')
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                })
                .then((json) => {
                    this.permanentAddressStates = json;
                    this.businessAddressStates = json;
                    this.localAddressStates = json;
                    this.fetchCountry();
                    this.fetchContactCountry();
                })
                .catch((error) => {
                    console.error(error);
                })
        },

    updateAddressData() {
      this.isSubmitting = true;
      this.errorMessage = "";

// console.log( "updateAddressData()" );

      if( this.passedEthnicity <= 0 ) {
        this.isEthinicity = false;
        this.errorisEthinicity = "Please select Ethinicity."
        this.isSubmitting = false;
      }
            
      if( this.addresses.local.isPreferredAddress && this.addresses.business.isPreferredAddress && this.addresses.permanent.isPreferredAddress ) {
        this.errorMessage = "At least one Primary address should be selected."
        this.isMessage = false;
        this.isSubmitting = false;
      }

      if( !this.phones.home.isPrimary && !this.phones.business.isPrimary && !this.phones.mobile.isPrimary ) {
        this.errorMessage = "At least one Primary contact number should be selected. Please enter the required details."
        this.isMessage = false;
        this.isSubmitting = false;
        return( false );
        }

      this.validateContactDetails();
      if( !this.isValidContactDetails || !this.isSubmitting ) {
        this.isSubmitting = false;
        this.isMessage = false;
        this.errorMessage = "Please enter the required details.";
        return( false );
        }

      if( this.addresses.local.isPreferredAddress || this.addresses.business.isPreferredAddress || this.addresses.permanent.isPreferredAddress ) {
      // NOTE: Already verified one is true above (line 531)!
        this.isPermanentSubmitted = true;
        this.validateAddress();

        if( this.isSubmitting ) {
// console.log( 'GET /api/UserAPI/save-profile' );
          fetch('/api/UserAPI/save-profile', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              SessionId: "",
              Ethnicity : this.passedEthnicity,
              "HomePhone": {
                "CountryId": this.phones.home.country,
                "PhoneNumber": this.phones.home.phone,
                "IsPrimary": this.phones.home.isPrimary
              },
              "WorkPhone": {
                "CountryId": this.phones.business.country,
                "PhoneNumber": this.phones.business.phone,
                "IsPrimary": this.phones.business.isPrimary
              },
              "CellPhone": {
                "CountryId": this.phones.mobile.country,
                "PhoneNumber": this.phones.mobile.phone,
                "IsPrimary": this.phones.mobile.isPrimary
              },

              "LocalAddress": {
                AddressType: this.addresses.local.addressType,
                Address1: this.addresses.local.address1,
                Address2: this.addresses.local.address2,
                Address3: this.addresses.local.address3,
                City: this.addresses.local.city,
                State: this.addresses.local.state,
                Country: "U.S.A.",
                Province: "",
                Company: "",
                Position: "",
                IsPreferredAddress: this.addresses.local.isPreferredAddress,
                EmailAddress: document.getElementById('hdnEmail').value,
                ZipCode: this.addresses.local.zipCode,
              },
              "BusinessAddress": {
                AddressType: this.addresses.business.addressType,
                Address1: this.addresses.business.address1,
                Address2: this.addresses.business.address2,
                Address3: "",
                City: this.addresses.business.city,
                State: this.addresses.business.country == "U.S.A." ? this.addresses.business.state : "",
                Country: this.addresses.business.country,
                Province: this.addresses.business.country != "U.S.A." ? this.addresses.business.province : "",
                Company: this.addresses.business.company,
                Position: "",
                IsPreferredAddress: this.addresses.business.isPreferredAddress,
                EmailAddress: document.getElementById('hdnEmail').value,
                ZipCode: this.addresses.business.zipCode,
              },
              "InternationalAddress": {
                AddressType: this.addresses.permanent.addressType,
                Address1: this.addresses.permanent.address1,
                Address2: this.addresses.permanent.address2,
                Address3: this.addresses.permanent.address3,
                City: this.addresses.permanent.city,
                State: "",
                Country: this.addresses.permanent.country,
                Province: this.addresses.permanent.province,
                Company: "",
                Position: "",
                IsPreferredAddress: this.addresses.permanent.isPreferredAddress,
                EmailAddress: document.getElementById('hdnEmail').value,
                ZipCode: this.addresses.permanent.zipCode,
              }
            })
            }).then(( response ) => {
              return response.json();
            }).then(( response ) => {

// console.log( 'response: ' + JSON.stringify( response ));

              this.isSubmitting = false;
              if( response != undefined && response.isSuccess ) {                                
                if( response.redirectPath != "" )
                  window.location.href = response.redirectPath;
                else if( response.redirectPath == "" && window.location.href.includes( "/cart/profile-update" )) {
                  window.location.href = CartSummaryUrl;
                }
              } else {
                this.isMessage = false;
                this.errorMessage = response.message;
              }
            });
          } else {
            this.isSubmitting = false;
            this.isMessage = false;
            this.errorMessage = "Please enter the required details.";
          }
        }
    },
        validateContactDetails() {
            this.isValidContactDetails = true;
            if (this.phones.home.isPrimary) {
                if (this.phones.home.phone == "") {
                    this.isHomePhoneError = true;
                    this.isValidContactDetails = false;
                }
            } else if (this.phones.business.isPrimary) {
                if (this.phones.business.phone == "") {
                    this.isBusinessPhoneError = true;
                    this.isValidContactDetails = false;
                }
            }
            else if (this.phones.mobile.isPrimary) {
                if (this.phones.mobile.phone == "") {
                    this.isMobilePhoneError = true;
                    this.isValidContactDetails = false;
                }
            }


        },

    resetAddressValidators() {
// console.log( 'resetAddressValidators()' );
      this.isLocalAddress1Error = "";
      this.isLocalCityError = "";
      this.isLocalStateError = "";
      this.isLocalZipCodeError = "";

      this.isBusinessAddress1Error = "";
      this.isBusinessCityError = "";
      this.isBusinessProvinceError = "";
      this.isBusinessStateError = "";
      this.isBusinessCountryError = "";
      this.isBusinessZipCodeError = "";

      this.isPermanentAddress1Error = "";
      this.isPermanentCityError = "";
      this.isPermanentCountryError = "";
      this.isPermanentZipCodeError = "";

      this.message = "";
      this.isSubmitting = true;               // Assume inputs are valid. Set false if address not updated due to one or more invalid inputs.
      this.preferredAddressComplete = false;  // Assume primary (preferred) address is not complete. Set true if primary address is saved.
    },

    validateAddress() {
      this.resetAddressValidators();

      if( this.addresses.local.isPreferredAddress ) {
        if (this.addresses.local.address1 == "") {
          this.isLocalAddress1 = false;
          this.isLocalAddress1Error = "Please enter Street Address";
          this.isSubmitting = false;
        } else {
          this.isLocalAddress1 = true;
        }
        if (this.addresses.local.city == "") {
          this.isLocalCity = false;
          this.isLocalCityError = "Please enter City";
          this.isSubmitting = false;
        } else {
          this.isLocalCity = true;
        }
        if (this.addresses.local.state == "") {
          this.isLocalState = false;
          this.isLocalStateError = "Please select US State";
          this.isSubmitting = false;
        } else {
          this.isLocalState = true;
        }
        if (this.addresses.local.zipCode == "") {
          this.isLocalZipCode = false;
          this.isLocalZipCodeError = "Please enter Postal Code";
          this.isSubmitting = false;
        } else {
          this.isLocalZipCode = true;
        }
      } else if (this.addresses.permanent.isPreferredAddress) {
        if (this.addresses.permanent.address1 == "") {
          this.isPermanentAddress1 = false;
          this.isPermanentAddress1Error = "Please enter Street Address";
          this.isSubmitting = false;
        } else {
          this.isPermanentAddress1 = true;
        }
        if (this.addresses.permanent.city == "") {
          this.isPermanentCity = false;
          this.isPermanentCityError = "Please enter City";
          this.isSubmitting = false;
        } else {
          this.isPermanentCity = true;
        }
        if (this.addresses.permanent.country == "") {
          this.isPermanentCountry = false;
          this.isPermanentCountryError = "Please select Country";
          this.isSubmitting = false;
        } else {
          this.isPermanentCountry = true;
        }
        if (this.addresses.permanent.zipCode == "") {
          this.isPermanentZipCode = false;
          this.isPermanentZipCodeError = "Please enter Postal Code";
          this.isSubmitting = false;
        } else {
          this.isPermanentZipCode = true;
        }
      } else if (this.addresses.business.isPreferredAddress) {
        if (this.addresses.business.company == "") {
          this.isBusinessCompany = false;
          this.isBusinessCompanyError = "Please enter Company Employer Name";
          this.isSubmitting = false;
        } else {
          this.isBusinessCompany = true;
        }
        if (this.addresses.business.address1 == "") {
          this.isBusinessAddress1 = false;
          this.isBusinessAddress1Error = "Please enter Street Address";
          this.isSubmitting = false;
        } else {
          this.isBusinessAddress1 = true;
        }
        if (this.addresses.business.city == "") {
          this.isBusinessCity = false;
          this.isBusinessCityError = "Please enter City";
          this.isSubmitting = false;
        } else {
          this.isBusinessCity = true;
        }
        if (this.addresses.business.country == "U.S.A." && this.addresses.business.state == "") {
          this.isBusinessState = false;
          this.isBusinessStateError = "Please select US State";
          this.isSubmitting = false;
        } else {
          this.isBusinessState = true;
        }
/* 2025-03-04 TBH - Province optional on Business address if country is not "U.S.A."
        if (this.addresses.business.country != "U.S.A." && this.addresses.business.province == "") {
          this.isBusinessProvince = false;
          this.isBusinessProvinceError = "Please enter province";
          this.isSubmitting = false;
        } else {
          this.isBusinessProvince = true;
        }
*/
        if (this.addresses.business.country == "") {
          this.isBusinessCountry = false;
          this.isBusinessCountryError = "Please select country";
          this.isSubmitting = false;
        } else {
          this.isBusinessCountry = true;
        }
        if (this.addresses.business.zipCode == "") {
          this.isBusinessZipCode = false;
          this.isBusinessZipCodeError = "Please enter Postal Code";
          this.isSubmitting = false;
        } else {
          this.isBusinessZipCode = true;
        }
      }
// console.log( 'validateAddress() - End' );
    },

    init() {
// console.log( 'init()' );
      this.getStates();
      this.fetchEthnicities();
      this.bindAddresses();
    }
  }
}